import { useLingui } from "@lingui/react";

type IUnits = "seconds" | "minutes" | "hours" | "milliseconds";

const UNITS_BY_LANG_MAP: Record<string, Record<string, string>> = {
  en: {
    h: "h",
    m: "m",
  },
  ru: {
    h: "ч",
    m: "м",
  },
};

const getSeconds = (value: number, units: IUnits): number => {
  const multiplierByUnits = {
    hours: 3600,
    milliseconds: 0.001,
    minutes: 60,
    seconds: 1,
  };
  const multiplier = multiplierByUnits[units];
  if (!multiplier) throw new Error(`Unknown units "${units}"`);
  return value * multiplier;
};

// may be replaced with moment js if more sophisticated behaviour will be required
export const useLocalTimeDelta = () => {
  const {
    i18n: { locale },
  } = useLingui();

  return (
    value: number,
    units: IUnits,
    format: "H:mm:ss" | "H?'h' m?'m'",
  ): string => {
    let seconds = getSeconds(value, units);

    const hours = (seconds / 3600) | 0;
    let minutes = ((seconds - 3600 * hours) / 60) | 0;
    seconds = Math.floor(seconds - 3600 * hours - 60 * minutes) | 0;

    if (format === "H:mm:ss") {
      return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    } else if (format === "H?'h' m?'m'") {
      minutes = Math.floor(minutes + seconds / 60) | 0;
      const units = UNITS_BY_LANG_MAP[locale] || UNITS_BY_LANG_MAP["en"];
      const h = units["h"];
      const m = units["m"];
      if (hours && minutes) return `${hours}${h} ${minutes}${m}`;
      if (hours && !minutes) return `${hours}${h}`;
      if (!hours) return `${minutes}${m}`;
    }

    throw new Error(`Unknown format: ${format}`);
  };
};
